import deleteByKey from './deleteByKey';

function deleteDates(data) {
  return deleteByKey(data, ['created_at', 'updated_at']);
}

export default deleteDates;
